module.exports = __webpack_public_path__ + "img/manajemen_data.777e53ef.svg";